<script lang="ts">
  import { type PlayerInterface } from '@foundation-player/loader';
  import { getContext } from 'svelte';
  import Backward10 from '../../shared/assets/icons/Backward10.svelte';
  import Forward10 from '../../shared/assets/icons/Forward10.svelte';
  import IconButton from '../../shared/components/IconButton.svelte';
  import type { FocusLayer, FocusItem } from '../../shared/focus-manager/focus-types';
  import type { IconButtonSize } from '../../shared/types/icon-button';
  import type { PlayerStateContext } from '../../shared/types/player-state';
  import type { SeekOffsetInSeconds } from '../types/internal/seek';

  export let player: PlayerInterface;
  export let seekOffsetInSeconds: SeekOffsetInSeconds = 10;
  export let size: IconButtonSize = 'm';
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { currentTime, linearAdPlaying } = getContext<PlayerStateContext>('playerState');

  const seek = () => {
    player.seek($currentTime + seekOffsetInSeconds);
  };
</script>

<IconButton
  title={seekOffsetInSeconds < 0
    ? `${Math.abs(seekOffsetInSeconds)}s zurückspulen`
    : `${seekOffsetInSeconds}s vorspulen`}
  {size}
  {focusLayer}
  {focusName}
  on:click={seek}
  disabled={$linearAdPlaying}
>
  {#if seekOffsetInSeconds < 0}
    <Backward10 aria-hidden="true" />
  {:else}
    <Forward10 aria-hidden="true" />
  {/if}
</IconButton>
